import { call, put, takeEvery, takeLatest, fork, all } from 'redux-saga/effects';
import UserSaga from './UserSaga';
import NotificationSaga from './NotificationSaga';

function* RootSaga() {
  yield all([UserSaga(), NotificationSaga()]);
}

export default RootSaga;
